import { useCallback, useMemo } from 'react';
import { trackUserInteraction } from '../utils/usageTracker';
const useTipHandlers = ({
  coachingTipsId,
  tipId,
  setCurrentTipId,
  isOpen,
  dismissCoachingTips
}) => {
  const onTipClick = useCallback(() => {
    const logAction = `${isOpen ? 'close' : 'open'} coaching tip`;
    trackUserInteraction(logAction, coachingTipsId, tipId);
    setCurrentTipId(isOpen ? '' : tipId); // If coaching tip is open already we set current tip to '' to close it
  }, [tipId, coachingTipsId, isOpen, setCurrentTipId]);
  const onOpenChangeTip = useCallback(evt => {
    if (!evt.target.value) {
      trackUserInteraction('click outside close tip', coachingTipsId, tipId);
      setCurrentTipId('');
    }
  }, [coachingTipsId, tipId, setCurrentTipId]);
  const onTurnOffClick = useCallback(() => {
    trackUserInteraction('turn off coaching tips', coachingTipsId, tipId);
    setCurrentTipId('');
    dismissCoachingTips();
  }, [dismissCoachingTips, coachingTipsId, tipId, setCurrentTipId]);
  const onStepChange = useCallback(({
    target
  }) => {
    const {
      value
    } = target;
    const targetStep = value + 1;
    trackUserInteraction('coaching tip step change', coachingTipsId, tipId, `change to step ${targetStep}`);
  }, [coachingTipsId, tipId]);
  return useMemo(() => ({
    onOpenChangeTip,
    onStepChange,
    onTipClick,
    onTurnOffClick
  }), [onOpenChangeTip, onStepChange, onTipClick, onTurnOffClick]);
};
export default useTipHandlers;